import { PayloadAction } from '@reduxjs/toolkit';
import {
    IFetchTableDataByIdAction,
    IFetchTableNextPageAction,
    IHandlePathChangedAction,
} from '../redux/interface';
import { call, put, select } from 'redux-saga/effects';
import {
    formatQueryParams,
    formatTableState,
    mapResponseByTableId,
} from './manager';
import { tablesActions, tablesSelectors } from '../redux';
import { fetchTableData } from '../../apis/tables';
import { reportsSelectors } from '../../reports/redux/selectors';
import {
    getQueryParamsString,
    tableDataBaseUrls,
    TableIds,
} from '../../../common';
import { globalSetQueryParams, ITableState } from '../../../base';
import { IServerPaginatedResponse } from '../../../common/interfaces/table.interface';

export function* fetchTableDataById(
    action: PayloadAction<IFetchTableDataByIdAction>
) {
    try {
        const { tableId, formData, page, baseColors } = action.payload;
        const tableState: ITableState = yield select((state) =>
            tablesSelectors.getTablesState(state, tableId)
        );
        const queryParams = formatQueryParams(tableState, page, formData);

        let response;
        if (tableId === TableIds.HIRING_SOURCES) {

            const reportFilter = yield select(
                reportsSelectors.getSourceOfHireFilter
            );
            Object.assign(queryParams, reportFilter);
        }
        const tableDataBaseUrl = tableDataBaseUrls[tableId];
        if (!tableDataBaseUrl) {
            throw new Error(`No API URL found for tableId: ${tableId}`);
        }
        ({ response } = yield call(
            fetchTableData,
            tableDataBaseUrl,
            queryParams
        ));
        if (response?.status === 200) {
            const responseData: IServerPaginatedResponse = response.data;
            const formattedData = mapResponseByTableId(
                tableId,
                responseData.results || [],
                baseColors
            );

            yield put(
                tablesActions.setRowsDataById({
                    tableId,
                    data: formattedData,
                    page,
                })
            );
            const currentEntitiesCount: number = formattedData.length;
            const formattedTableState = formatTableState(
                tableId,
                queryParams,
                currentEntitiesCount,
                responseData
            );
            yield put(
                tablesActions.setTableStateById({
                    tableId,
                    tableState: formattedTableState,
                })
            );
            if (tableId !== TableIds.HIRING_SOURCES) {
                const updatedUrl = getQueryParamsString(queryParams);
                globalSetQueryParams(updatedUrl);
            }
        } else {
            throw new Error(response?.error); //TODO: Fix error
        }
    } catch (error) {
        console.log(error);
    }
}

export function* handlePathChanged(
    action: PayloadAction<IHandlePathChangedAction>
) {
    const { path } = action.payload;
    const pathElements = path?.replace(/\/+$/, '').split('/');
    const leadingPath = pathElements[pathElements.length - 1];
    const tableId = Object.keys(tableDataBaseUrls).find(
        (id) => tableDataBaseUrls[id] === leadingPath + '/'
    );
    if (tableId) {
        const tableState: ITableState = yield select(
            tablesSelectors.getTablesState,
            tableId
        );
        if (!tableState.initialLoad) {
            const updatedUrl = getQueryParamsString(
                formatQueryParams(tableState, tableState.currentPage)
            );
            globalSetQueryParams(updatedUrl);
        }
    }
}

export function* fetchTableNextPageSaga(
    action: PayloadAction<IFetchTableNextPageAction>
) {
    try {
        const { tableId, baseColors } = action.payload;
        const tableState: ITableState = yield select(
            tablesSelectors.getTablesState,
            tableId
        );
        const currentPage = tableState.currentPage;
        if (currentPage < tableState.totalPages) {
            yield put(
                tablesActions.fetchTableDataById({
                    tableId,
                    formData: { ...tableState, tableId: tableState.id },
                    page: currentPage + 1,
                    baseColors,
                })
            );
        }
    } catch (error) {
        console.log(`Failed to fetch next page: ${error}`); //TODO: Saga error handler
    }
}
